import { ErrorMessageStrategy } from '@shared/utils/interfaces';

export const aggregatorRequestFailedStrategy: ErrorMessageStrategy = () => {
  return {
    translationKey: 'errors.AGGREGATOR_REQUEST_FAILED',
  };
};
